import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource/fraunces/400.css'
import '@fontsource/fraunces/400-italic.css'
import '@fontsource/fraunces/500.css'
import '@fontsource/fraunces/500-italic.css'
import './styles/tokens.css'
import './index.css'
import App from './App'
import { captureReferralFromUrl } from './lib/captureReferral'
import { initSentry }  from './lib/sentry'
import { initPostHog } from './lib/posthog'

// Init observability BEFORE React mounts so any error during initial render
// is captured. Both helpers no-op gracefully if their env vars are missing,
// so dev / preview / unconfigured environments don't crash.
initSentry()
initPostHog()

// Capture ?ref= from any landing URL into storage before React mounts, so the
// code survives across route changes and is ready when the user reaches /sign-up.
captureReferralFromUrl()

const queryClient = new QueryClient()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch(err => console.log('SW registration failed:', err))
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
